// Collection Filters JavaScript
document.addEventListener('DOMContentLoaded', function() {
  // Price range slider functionality
  const minSlider = document.getElementById('price-min');
  const maxSlider = document.getElementById('price-max');
  const minInput = document.getElementById('min-price-input');
  const maxInput = document.getElementById('max-price-input');
  
  if (minSlider && maxSlider && minInput && maxInput) {
    // Initialize sliders
    function updateSlider() {
      // Set slider background to show range
      const minVal = parseInt(minSlider.value);
      const maxVal = parseInt(maxSlider.value);
      
      // Ensure min doesn't exceed max
      if (minVal > maxVal) {
        minSlider.value = maxVal;
      }
      
      // Update input fields
      minInput.value = minSlider.value;
      maxInput.value = maxSlider.value;
    }
    
    // Update input fields when sliders change
    minSlider.addEventListener('input', updateSlider);
    maxSlider.addEventListener('input', updateSlider);
    
    // Update sliders when input fields change
    minInput.addEventListener('change', function() {
      const minVal = parseInt(minInput.value);
      const maxVal = parseInt(maxSlider.value);
      
      if (minVal < 0) {
        minInput.value = 0;
      } else if (minVal > maxVal) {
        minInput.value = maxVal;
      }
      
      minSlider.value = minInput.value;
    });
    
    maxInput.addEventListener('change', function() {
      const minVal = parseInt(minSlider.value);
      const maxVal = parseInt(maxInput.value);
      const maxLimit = parseInt(maxSlider.max);
      
      if (maxVal > maxLimit) {
        maxInput.value = maxLimit;
      } else if (maxVal < minVal) {
        maxInput.value = minVal;
      }
      
      maxSlider.value = maxInput.value;
    });
    
    // Initialize slider values
    updateSlider();
  }
  
  // Clear all filters button
  const clearAllButton = document.querySelector('.clear-all-button');
  
  if (clearAllButton) {
    clearAllButton.addEventListener('click', function() {
      // Clear all checkboxes
      const checkboxes = document.querySelectorAll('.filter-checkbox input[type="checkbox"]');
      checkboxes.forEach(checkbox => {
        checkbox.checked = false;
      });
      
      // Reset price range
      if (minSlider && maxSlider && minInput && maxInput) {
        minSlider.value = minSlider.min;
        maxSlider.value = maxSlider.max;
        minInput.value = minSlider.min;
        maxInput.value = maxSlider.max;
      }
      
      // If using URL parameters, redirect to base collection URL
      const url = new URL(window.location.href);
      const pathParts = url.pathname.split('/');
      
      // Preserve the collection path but remove query parameters
      if (pathParts.length >= 3 && pathParts[1] === 'collections') {
        window.location.href = `/collections/${pathParts[2]}`;
      } else {
        // Remove all query parameters
        window.location.href = url.pathname;
      }
    });
  }
  
  // Mobile filters toggle
  const filtersToggle = document.querySelector('.filters-toggle');
  const filtersModal = document.querySelector('.filters-modal');
  const filtersCloseButton = document.querySelector('.filters-modal-close');
  
  if (filtersToggle && filtersModal) {
    filtersToggle.addEventListener('click', function() {
      filtersModal.style.display = 'block';
      document.body.style.overflow = 'hidden';
    });
    
    if (filtersCloseButton) {
      filtersCloseButton.addEventListener('click', function() {
        filtersModal.style.display = 'none';
        document.body.style.overflow = '';
      });
    }
    
    // Close modal when clicking outside
    window.addEventListener('click', function(event) {
      if (event.target === filtersModal) {
        filtersModal.style.display = 'none';
        document.body.style.overflow = '';
      }
    });
  }
  
  // Filter form submission
  const filterCheckboxes = document.querySelectorAll('.filter-checkbox input[type="checkbox"]');
  
  filterCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function() {
      // Create URL with filter parameters
      applyFilters();
    });
  });
  
  // Apply filters function
  function applyFilters() {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    
    // Clear existing filter params
    ['filter.age', 'filter.skills', 'price'].forEach(param => {
      const paramsToRemove = [];
      params.forEach((value, key) => {
        if (key.startsWith(param)) {
          paramsToRemove.push(key);
        }
      });
      paramsToRemove.forEach(key => params.delete(key));
    });
    
    // Add checked filters
    const ageFilters = document.querySelectorAll('input[name^="filter.age"]:checked');
    const skillsFilters = document.querySelectorAll('input[name^="filter.skills"]:checked');
    
    ageFilters.forEach(filter => {
      params.append(filter.name, filter.value);
    });
    
    skillsFilters.forEach(filter => {
      params.append(filter.name, filter.value);
    });
    
    // Add price range
    if (minSlider && maxSlider) {
      params.set('price.min', minSlider.value);
      params.set('price.max', maxSlider.value);
    }
    
    // Update URL
    url.search = params.toString();
    window.location.href = url.toString();
  }
  
  // Initialize filter state from URL parameters
  function initFiltersFromUrl() {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    
    // Set checkbox states
    params.forEach((value, key) => {
      if (key.startsWith('filter.')) {
        const checkbox = document.querySelector(`input[name="${key}"]`);
        if (checkbox) {
          checkbox.checked = true;
        }
      }
    });
    
    // Set price range
    const minPrice = params.get('price.min');
    const maxPrice = params.get('price.max');
    
    if (minPrice && minSlider) {
      minSlider.value = minPrice;
      minInput.value = minPrice;
    }
    
    if (maxPrice && maxSlider) {
      maxSlider.value = maxPrice;
      maxInput.value = maxPrice;
    }
  }
  
  // Initialize filters from URL
  initFiltersFromUrl();
});